import { BellRing, ShieldCheck, Sparkles } from "lucide-react";
import { TRIAL_DAYS, TRIAL_PLAN_NAME } from "@omnicanvas/core";

// The no-card trial terms, shared by /pricing and the homepage closing CTA so
// the promise is written once and the day counts come from TRIAL_DAYS.
export function TrialPromise({ className = "" }: { className?: string }) {
  return (
    <div className={`mx-auto max-w-4xl overflow-hidden rounded-2xl border border-indigo-200 bg-indigo-50 ${className}`}>
      <div className="px-5 py-4 text-center">
        <div className="flex items-center justify-center gap-2 font-semibold text-indigo-700">
          <Sparkles size={18} />
          Nothing to cancel, because there is nothing to charge
        </div>
        <p className="mt-1 text-sm text-indigo-600">
          We never take a card to start your {TRIAL_DAYS}-day {TRIAL_PLAN_NAME} trial,
          so the trial cannot quietly turn into a bill. Paying is a separate
          choice you make later, on purpose.
        </p>
      </div>
      <div className="grid gap-px bg-indigo-200 sm:grid-cols-3">
        <div className="bg-white p-4">
          <div className="text-[10px] font-bold uppercase tracking-[0.14em] text-indigo-600">Today</div>
          <div className="mt-1 text-sm font-bold text-slate-900">Pro unlocks immediately</div>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">
            Create a free account. No payment form and no charge.
          </p>
        </div>
        <div className="bg-white p-4">
          <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.14em] text-indigo-600">
            <BellRing size={11} />
            Day {TRIAL_DAYS - 3}
          </div>
          <div className="mt-1 text-sm font-bold text-slate-900">We remind you first</div>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">
            We send a reminder three days before the trial ends.
          </p>
        </div>
        <div className="bg-white p-4">
          <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.14em] text-indigo-600">
            <ShieldCheck size={11} />
            Day {TRIAL_DAYS}
          </div>
          <div className="mt-1 text-sm font-bold text-slate-900">Free continues automatically</div>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">
            If you do nothing, your account returns to Free. Your notes stay yours.
          </p>
        </div>
      </div>
    </div>
  );
}
